import { DANGER_RED, DangerZoneRow } from '../../primitives';

/** The danger-zone "Cancel workshop" row: a start button, then an inline
 *  confirm that continues to the rebooking picker. */
export function CancelWorkshopRow({
  confirming,
  onStart,
  onContinue,
  onCancel,
}: {
  confirming: boolean;
  onStart: () => void;
  onContinue: () => void;
  onCancel: () => void;
}) {
  if (!confirming) {
    return (
      <DangerZoneRow
        title="Cancel workshop"
        divided
        note="Moves every booked customer to another workshop and emails them the new details. This can’t be undone."
      >
        <button
          type="button"
          className="nb-btn"
          onClick={onStart}
          style={{ color: DANGER_RED, borderColor: 'rgba(192,57,43,.4)', whiteSpace: 'nowrap' }}
        >
          Cancel workshop
        </button>
      </DangerZoneRow>
    );
  }

  return (
    <DangerZoneRow
      title="Cancel workshop"
      warn
      divided
      note="You’ll pick the workshop to move all booked customers into next. They’ll be emailed the new details."
    >
      <button type="button" className="nb-btn nb-btn-ghost" onClick={onCancel}>
        Keep workshop
      </button>
      <button
        type="button"
        className="nb-btn"
        onClick={onContinue}
        style={{
          color: '#fff',
          background: DANGER_RED,
          borderColor: DANGER_RED,
          whiteSpace: 'nowrap',
        }}
      >
        Continue to rebooking
      </button>
    </DangerZoneRow>
  );
}
